<template lang="pug">
  div
    div.p1.basic700--text Select delivery service
    v-radio-group(v-if="showRadio" v-model="localdeliveryService" row dense)
      v-row(no-gutters)
        v-col
          v-radio(value="motorcycle" color="info500")
            template(v-slot:label)
              div.p2.primary--text Motorcycle
        v-col
          v-radio(value="car" color="info500")
            template(v-slot:label)
              div.p2.primary--text Car
    template
      template(v-if="errorRate")
        div.mt-3.s2.danger500--text {{ errorRate.error }}

      template(v-for="localDelivery in localDeliveries")
        div.px-2.py-4.my-2(:style="localDelivery.disabled ? disabledBorder : (selectedFulfilment && localDelivery.signature === selectedFulfilment.signature) ? activeBorder : inactiveBorder" @click="localDelivery.disabled ? '' : selectedFulfilment = localDelivery")
          v-row(no-gutters align="center")
            v-col.shrink
              div(style="width: 72px" align="center")
                v-img(v-if="localDelivery.meta_data" :src="localDelivery.meta_data.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
            v-col.pl-2
              div.p2.basic700--text {{ localDelivery.title }}
              div.p2.basic700--text(v-if="localDelivery.meta_data") {{ localDelivery.meta_data.service_type }}
            v-col(cols="3")
              div.p2.basic700--text {{ localDelivery.fee | displayPrice }}
          div.s2.danger500--text(v-if="localDelivery.error") {{ localDelivery.error }}

</template>

<script>
export default {
  name: 'SelectLocalDelivery',
  props: ['parentRates', 'parentSelectedFulfilment'],
  data: () => ({
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
    },
    disabledBorder: {
      borderRadius: '4px',
      backgroundColor: 'var(--v-basic300)',
      opacity: 0.5
    },
    motorcycleLocalDeliveries: null,
    carLocalDeliveries: null,
    localdeliveryService: null,
    showRadio: true,
  }),
  computed: {
    rates: {
      get () {
        return this.parentRates
      },
      set (newValue) {
        this.$emit('update:parentRates', newValue)
      }
    },
    errorRate() {
      return this.rates.find(rate => rate.disabled && rate.error.includes('local delivery')) || null
    },
    selectedFulfilment: {
      get () {
        return this.parentSelectedFulfilment
      },
      set (newValue) {
        this.$emit('update:parentSelectedFulfilment', newValue)
      }
    },
    localDeliveries () {
      if (this.localdeliveryService === 'motorcycle') {
        return this.motorcycleLocalDeliveries
      } else if (this.localdeliveryService === 'car') {
        return this.carLocalDeliveries
      } else {
        return []
      }
    }
  },
  watch: {
    rates: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          this.motorcycleLocalDeliveries = [...val.filter(f => f.meta_data && f.meta_data.service_type === 'motorcycle')]
          this.carLocalDeliveries = [...val.filter(f => f.meta_data && f.meta_data.service_type === 'car')]
          if (this.motorcycleLocalDeliveries.length === 0) {
            this.localdeliveryService = 'car'
            this.showRadio = false
          } else if (this.carLocalDeliveries.length === 0) {
             this.localdeliveryService = 'motorcycle'
             this.showRadio = false
          }
        }
      }
    },
    selectedFulfilment: {
      deep: true,
      handler (val) {
        if (val && val.meta_data) {
          this.localdeliveryService = val.meta_data.service_type
        }
      }
    }
  },
  mounted () {
  },
}
</script>

<style scoped>

</style>